module.exports = __webpack_public_path__ + "img/sdc2018-champion.ab124171.png";